module.exports = __webpack_public_path__ + "img/gr_unit.f9c76996.png";